export enum IntegrationSlugEnum {
  horusChift = 'horus-chift',
  octopusChift = 'octopus-chift',
  exactChift = 'exact-chift',
  peppol = 'peppol',
  odooChift = 'odoo-chift',
}

export enum IntegrationsStatusEnum {
  available = 'available',
  active = 'active',
  inactive = 'inactive',
  waiting_callback = 'waiting_callback',
  pending = 'pending',
  verification_required = 'verification_required',
}

export enum PeppolDeactivationReasons {
  userUpdated = 'user-updated',
  VATTypeUpdated = 'user-becomes-subject-to-VAT',
}

enum IntegrationTypeEnum {
  access = 'access',
  user = 'user',
}

export type CurrentIntegration = {
  _id: string;
  slug: IntegrationSlugEnum;
  status: IntegrationsStatusEnum;
  connection_url: string;
  connectionId: string;
  logo_url: string;
  icon_url: string;
};

export type PeppolCurrentIntegration = CurrentIntegration & {
  slug: IntegrationSlugEnum.peppol;
  metaData: PeppolIntegrationFormData;
  requiresUserVerification?: boolean;
  deactivationReason?: PeppolDeactivationReasons;
  documentExchangeType: DocumentExchangeTypeEnum;
};

export type AvailableIntegration = {
  type: IntegrationTypeEnum;
  slug: IntegrationSlugEnum;
  status: IntegrationsStatusEnum;
  logo_url: string;
  icon_url: string;
};

export enum PeppolIntegrationScheme {
  IBAN = 'IBAN',
  BE_VAT = 'BE:VAT',
  DE_VAT = 'DE:VAT',
}

export type PeppolIntegrationFormData = {
  firstName: string;
  lastName: string;
  address: {
    street: string;
    zip: string;
    city: string;
    country: string;
    state?: string;
  };
  identifier: string;
  scheme: PeppolIntegrationScheme;
  steuernummer?: string;
  companyName?: string;
};

export enum DocumentExchangeTypeEnum {
  send_only = 'send_only',
  send_and_receive = 'send_and_receive',
}

export type RegistrationOptions = {
  documentExchangeType: DocumentExchangeTypeEnum;
};
